import React, {Fragment, useMemo} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";
import GroheFeatureLockedBadge from "../groheFeature/groheFeatureLockedBadge";
import FeatureName from "../../../../visComponents/featureName";
import FeatureDescription from "../../../../visComponents/featureDescription";
import LookFeaturePairPrice from "../../../lookNavigation/lookMain/lookListFeature/lookFeaturePairPrice";
import GroheFeatureMoreInfoButton from "../groheFeature/groheFeatureMoreInfoButton";
import GroheFeatureOptions from "../groheFeature/groheFeatureOptions";
import LookFeatureOptions from "../../../lookNavigation/lookMain/lookFeature/lookFeatureOptions";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {isInStock} from "../../../lookNavigation/lookFunctions2";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import {getFeatureOptions} from "../../../lookNavigation/lookFunctions";
import GroheFeatureSQFTButton from "../groheFeature/groheFeatureSQFTButton";
import GroheFeatureQuantity from "../groheFeature/groheFeatureQuantity";
import {getCurrentLayout} from "../../../../appLayout";
import LookFeatureNotInStock from "../../../lookNavigation/lookMain/lookFeature/lookFeatureNotInStock";
import LookFeatureSku from "../../../lookNavigation/lookMain/lookFeature/lookFeatureSku";
import GroheFeatureNotInVisualizer from "../groheFeature/groheFeatureNotInVisualizer";
import {isFeatureNotInVisualizerNow} from "../../../../visComponents/featuresFunctions";

const GroheWizardContentFeature = (props) => {

  const {feature, wizardGroup, filterGroups} = props;

  const showPriceLocked = getFeatureIsLocked(feature);

  const layout = getCurrentLayout();
  const showPrice = !!layout.partIdExistInQtCategory(feature.partId, true)

  const colorOptions = getFeatureOptions(feature, filterGroups);

  const featureIsInStock = useMemo(() => isInStock(feature), [feature]);

  const showPriceInput = wizardGroup.multipleAddToCart && showPrice && !feature.dbFeature.hideQuantity;

  return (
    <div className={"grohe-feature grohe-wizard__feature" + (colorOptions && colorOptions.length ? " grohe-wizard__feature--with-options" : "")}>
      <LookFeatureImage forFeature={feature}/>
      {showPriceLocked ? (
        <GroheFeatureLockedBadge/>
      ) : (
        <Fragment>
          <div className="lk-title">
            <h2 className="lk-title__text bold"><FeatureName feature={feature} useCollectionName={true}/></h2>
          </div>
          <p className="lm-feature__content-model">
            <LookFeatureSku lookFeature={feature}/>
            <LookFeatureNotInStock lookFeature={feature}/>
          </p>
          <div className="lm-feature__content-description">
            <FeatureDescription feature={feature} textLength={80}/>
          </div>
          <div className="lk-feature__price">
            <div className="lk-feature__price-inner">
              {wizardGroup.multipleAddToCart && !showPrice && !feature.dbFeature.hideQuantity
                ? <GroheFeatureQuantity disabled={!featureIsInStock}
                                        hideTitle={true}
                                        feature={feature}
                                        isWizard={true}/> : null}
              <LookFeaturePairPrice lookFeature={feature}/>
              <GroheFeatureSQFTButton featureOpened={feature} isIcon={true} className="" />
            </div>
            {showPriceInput
              ? <GroheFeatureQuantity disabled={!featureIsInStock} feature={feature} isWizard={true}/> : <GroheFeatureMoreInfoButton/>}
          </div>
        </Fragment>
      )}
      {isFeatureNotInVisualizerNow(feature) ? <GroheFeatureNotInVisualizer/> : null}
      <div className="grohe-wizard__feature-block">
        <LookFeatureOptions isWizard={true}
                            activeFeature={feature}
                            wizardGroup={wizardGroup} />
        {showPriceInput ? <GroheFeatureMoreInfoButton/> : null}
      </div>
      <GroheFeatureOptions isWizard={true}
                           activeFeature={feature}
                           wizardGroup={wizardGroup}/>
    </div>
  )

};

GroheWizardContentFeature.propTypes = {
  feature: PropTypes.shape(featureInterface),
  wizardGroup: PropTypes.shape(wizardGroupInterface),
}

const mapStateToProps = (store) => {
  const {wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {filterGroups} = store.filterState;

  return {
    wizardActiveStep,
    wizardSelectedValues,
    filterGroups,
  };
};

export default connect(mapStateToProps)(GroheWizardContentFeature)
